// SweetAlert feedback for file uploads. `vm` is the calling component (needs this.$swal).
const reasonFrom = (error, response) => {
  const data = (error && error.response && error.response.data) || (response && response.data) || {}
  return data.Message || (error && error.message) || 'Please try again.'
}

export const uploadSuccess = (vm, text) => vm.$swal({
  icon: 'success',
  title: 'Upload successful',
  text,
  timer: 2500,
  showConfirmButton: false,
})

export const uploadFailed = (vm, { error, response } = {}) => vm.$swal({
  icon: 'error',
  title: 'Upload failed',
  text: `${reasonFrom(error, response)} Nothing was saved.`,
  confirmButtonText: 'OK',
  customClass: { confirmButton: 'btn btn-primary' },
  buttonsStyling: false,
})
